define([], function() {

  'use strict';

  return {
    contentChanged: "scribe:content-changed",
    legacyContentChanged: "content-changed",
    destroy: "scribe:destroy"
  };
});



// WEBPACK FOOTER //
// ./app/statamic/resources/js/vendor/scribe-editor/events.js